export default __webpack_public_path__ + "static/media/Dominator's Boots.33c0ae3d.jpg";